// Not ready for development yet
// Used for testing a feature

export default function DocQA() {
    return(
        <div>
            App Side - DocQA
        </div>
    );
}